export default __webpack_public_path__ + "static/media/s2-grid2.686b57e2.jpg";